import { Dialog, DialogActions } from '@mui/material';
import { getCompanyConfigOld } from 'lib/api/company';
import { EvaluationReviews } from 'lib/common/EvaluationDetails';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { showAlert } from 'lib/functions/utils';
import { ChatWindow } from 'pages/Finance/Components/Financing/common/chat';
import FilesDialog from 'pages/Finance/Components/Financing/common/filesView';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import VerificationModule from '../../../../../Collection/components/Verification';

export const PAYOUT_AVAILABLE_STAGES = [
  'Aceptada',
  'Cedida',
  'Activa',
  'Completada',
  'En mora',
];
export const EXECUTED_STAGES = [
  'Activa',
  'Completada',
  'En mora',
  'Completada',
];

const ShoppingDialogRecieved = (props: any) => {
  const { openShoppingCart, setOpenShoppingCart, selectedRequest, setUp } =
    props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const [config, setConfig] = useState(0);
  const startValue = 0;
  const goToRiskTimes = 1;

  async function getVerificationChatConfig() {
    try {
      const configuration = await getCompanyConfigOld(
        dispatch,
        'system_verifications_show_operation_chat',
      );
      setConfig(configuration || 0);
    } catch (error) {
      showAlert(
        dispatch,
        'error',
        'No se encontró la configuración de verificaciones',
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void getVerificationChatConfig();
  }, []);

  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    );
  };

  if (loading) return <CenteredCircularProgress type="dialog" />;

  const tabs = [
    {
      index: 0,
      label: 'Verificación',
      component: (
        <VerificationModule
          preSettedFactoringRequestId={selectedRequest?.id}
          preSettedConfirmationType="all"
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
        />
      ),
      path: 'recieved',
    },
    {
      index: 1,
      label: 'Riesgo',
      component: (
        <ImportedModuleLayout>
          <EvaluationReviews
            requestEntries={[
              {
                requestId: selectedRequest.firstQuote?.id ?? selectedRequest.id,
                requestType: 'factoring-request',
              },
              {
                requestId: selectedRequest.id,
                requestType: 'factoring-request-payers',
              },
            ]}
          />
        </ImportedModuleLayout>
      ),
      path: 'recieved',
    },
    {
      index: 2,
      label: 'Archivos',
      component: (
        <FilesDialog
          openRequest={selectedRequest}
          requestType="factoring"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    ...[
      config
        ? {
            index: 3,
            label: 'Chat',
            component: (
              <ChatWindow
                selectedRequest={selectedRequest}
                requestType={'factoring'}
                setOpenShoppingCart={setOpenShoppingCart}
              />
            ),
          }
        : {
            index: 3,
            label: 'Chat',
            component: (
              <ChatWindow
                selectedRequest={selectedRequest}
                requestType={'verification'}
                setOpenShoppingCart={setOpenShoppingCart}
              />
            ),
          },
    ],
  ];

  return (
    <>
      <Dialog maxWidth="xl" fullWidth open={openShoppingCart}>
        <div style={{ padding: 20, minHeight: 200 }}>
          <EnhancedTab
            title={`Solicitud #${cellFormat(selectedRequest?.id, 'numeric-id')}`}
            startValue={startValue}
            tabs={tabs}
            updater={goToRiskTimes}
            chip={cellFormat(selectedRequest?.status, 'status')}
          />
        </div>
      </Dialog>
    </>
  );
};

export default ShoppingDialogRecieved;
